<template>
	<v-snackbar class="px-5 mt-2" style="height:auto;" centered v-model="snack" :timeout="3000" :color="snackColor">
    	<span style="color: black;">{{ snackText }}</span>
    </v-snackbar>
</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
name: 'SnackMessageBar',
data () {
	return {
		//snackColor: 'warning'
	}
},

computed: {
	...mapState({   	snackText: state => state.ui.snackText,
                        snackColor: state => state.ui.snackColor
						//snack: state => state.ui.snack,
				}),
    snack: {
        get () {
          return this.$store.state.ui.snack
        },
        set (value) {
            this.setSnack(value)
        }
    },
},

methods : {
	...mapMutations([ 	'setSnack',
					]),

	clickHandler : function () {
		//console.log("Clicked")
	}
},
}

</script>

<style>
</style>
